// extracted by mini-css-extract-plugin
export default {"root":"leZIX_leZIX","floating":"Ecphz_Ecphz","loader":"zTBrP_zTBrP","spin":"X6fyu_X6fyu","local":"SV48u_SV48u","message":"JuUBB_JuUBB"};